export default function getPath() {
    return this.path_prefix + this.path + this.path_postfix;
}